<template>
  <div class="hello screen-spacing">
    <div class="">
        <div class="h1 display-inline">Generate QR code
          <button class="tooltip-btn h3" type="button" v-on:click="alertInfo()" >
      <span class="question-mark">?</span>
    </button>
        </div>
        <SelectVenue ref="venueDropDown" @updateVenue="updateVenue"/>
         <div class="form-text ms-2">This name appears in the flyer header.</div>
    </div>
    <p class="mt-3 ms-2">Print your own  QR code?     <input type="checkbox" class="btn pl-3 ml-2" v-model="showCodes" id="TableName" aria-describedby="emailHelp">
    </p>

  <div class="ms-2" v-if="!showCodes && qrcodeString">
    <!-- Accent color -->
          <div class="mb-3">
            <label class="form-label d-flex align-items-center gap-2">
              <span>Select accent color</span>
              <span class="badge bg-light text-muted">affects header + buttons</span>
            </label>
            <div class="row g-2 align-items-center">
              <div class="col-auto">
                <input id="accent" type="color" class="form-control form-control-color" v-model="color" value="#000000" title="Choose color">
              </div>
              <div class="col">
                <input id="accentHex" type="text" class="form-control" v-model="color" value="#000000">
              </div>
            </div>
            <div id="accentStripe" class="mt-2 rounded" style="height: 20px;"></div>
          </div>


          <div class="mb-3">
            <div class="btn-group">
              <button id="downloadPrimary" type="button" class="btn btnAccent">Download</button>
              <button type="button" class="btn btnAccent dropdown-toggle dropdown-toggle-split" data-bs-toggle="dropdown" aria-expanded="false">
                <span class="visually-hidden">Toggle dropdown</span>
              </button>
              <ul class="dropdown-menu">
                <li><button class="dropdown-item" @click="makeFlyerPdf" data-variant="flyer">Flyer PDF</button></li>
                <li><button class="dropdown-item" @click="downloadSingleTable" data-variant="large">Large Table QR</button></li>
                <li><button class="dropdown-item" @click="downloadGrid" data-variant="small">Small Table QR</button></li>
                <li><button class="dropdown-item" @click="downloadStage" data-variant="stage">Stage QR</button></li>
              </ul>
            </div>
          </div>


        <div class="mb-2">
            <label class="form-label mt-2">Flyer description</label>
            <textarea id="desc" class="form-control" rows="4" maxlength="160" v-model="descriptionText"
              placeholder="Pick up at the Main Bar. We’ll send you a text when it’s ready!"></textarea>
            <div class="d-flex justify-content-between">
              <div class="form-text">Shown under the QR on the flyer.</div>
              <div class="form-text"><span id="descCount">0</span>/160</div>
            </div>
          </div>  

  </div>

  <div class="barcode-container" v-if="showCodes && qrcodeString">
        
        <h1>{{this.currentVenue.venue_name}}: {{'https://vibe-tap.com/open?venueID='+currentVenueId}}</h1>
        
  
    <div class="row">
          <div
            v-for="(table, index) in tableList"
            :key="index"
            class="fs-3 mt-3"
          >
          <div><b>{{table.name}}</b>: {{ 'https://vibe-tap.com/open?tableID='+ table._id}}</div>
          </div>
      </div>
  </div>



  </div>


</template>

<script>
import SelectVenue from "../../components/SelectVenue.vue"
import tableService from "../../api/table.js"
import stageService from "../../api/stage.js"
import swal from 'sweetalert';
const qr = require("qrcode")
import {generateFlyerPDF, generateTableQRsPDF} from "../../utils/pdf"

export default {
  name: 'GenerateQRCode',
  components:{
   SelectVenue
  },
  data() {
    return {
        newItemType:"",
        currentVenueId:"",
        currentVenue:"",
        barList:[{Name:"RoofTop",Address:"",Description:"Immediatly on your left when entering",isEnabled:false}],   
        qrcodeString:"",
        tableList:[],
        stageList:[],
        showCodes: false,
        color:'',
        descriptionText:""

    };
  },
  methods:{
    async downloadStage(){
      var vue = this;
      stageService.getAllStages(this.currentVenueId).then(async data =>{
        if(data.length>0){
          const stageListWithQrCodes = await Promise.all(
    data.map(async item => {
      const qrcodeString = await vue.generateStageQrCode(item._id);
      return { 
        ...item, 
        qrcodeString 
      };
    })
  );
        this.stageList = stageListWithQrCodes
        console.log(this.stageList)
        await generateTableQRsPDF({
        tables: this.stageList,
        layout: "single",
        format: "a4",
        accentHex: this.color,
        showBorder: true, // nice for laminates
        fileName: `${this.currentVenue.venue_name}-stage.pdf`,
        caption:"Performers scan to enter social media and get tips"
      });
        }
        else{
          swal("","No stages have been setup.",{
          icon: "info", // You can customize the icon (info, success, error, warning, question)
        })
        }
          
     })
    },
    async downloadSingleTable() {
      if(this.tableList.length>0){
        await generateTableQRsPDF({
        tables: this.tableList,
        layout: "two-up",
        format: "a4",
        accentHex: this.color,
        showBorder: true, // nice for laminates
        fileName: `${this.currentVenue.venue_name}-table-single.pdf`,
      });
      }
      else{
        swal("","No tables have been setup.",{
          icon: "info", // You can customize the icon (info, success, error, warning, question)
        })
      }
      
    },
    async downloadGrid() {
      if(this.tableList.length>0){
      await generateTableQRsPDF({
        tables: this.tableList,
        layout: "grid",
        format: "a4",
        accentHex: this.color,
        showBorder: false, // grid + cut marks looks clean
        fileName: `${this.currentVenue.venue_name}-table-grid.pdf`,
      });
      }
      else{
        swal("","No tables have been setup.",{
          icon: "info", // You can customize the icon (info, success, error, warning, question)
        })
      }
    },
    async makeFlyerPdf() {
      await generateFlyerPDF({
        venueName: this.currentVenue.venue_name,
        logoUrl: this.currentVenue.picture,
        qrDataURL: this.qrcodeString,
        descriptionText:this.descriptionText && this.descriptionText!=""? this.descriptionText: "Pick up at the Main Bar. We’ll send you a text when it’s ready!",
        accentHex: this.color,
        fileName: `${this.currentVenue.venue_name}-flyer.pdf`,
      });
    },
   alertInfo(){
swal("Generating QR Code", "Select a venue or event to view QR codes for each pickup/drop-off location. To use your own QR code solution, copy the string from the 'Print Your Own QR Code'.")    },
    async updateVenue(e){
      if(e.target.value!=0){
         var vue = this;
        this.currentVenueId = e.target.value
        this.qrcodeString = await vue.generateQrCode(e.target.value)
        console.log(this.qrcodeString)
        this.currentVenue = this.venueList.find(item => item._id === this.currentVenueId)
        tableService.getAllTables(e.target.value).then(async data =>{
          const tableListWithQrCodes = await Promise.all(
    data.map(async item => {
      const qrcodeString = await vue.generateQrCode(this.currentVenueId,item._id);
      return { 
        ...item, 
        qrcodeString 
      };
    })
  );
        this.tableList = tableListWithQrCodes
        console.log(this.tableList)
     })
      }
      else{
        this.reset()
      }
    },
    async generateQrCode(venueID,tableID) {
      

    const qrData = tableID ? 'https://order.vibe-tap.com?tableID='+tableID:'https://order.vibe-tap.com?venueID='+venueID;
    console.log(qrData)

  return new Promise((resolve, reject) => {
    qr.toDataURL(qrData, function(err, code) {
      if (err) {
        console.log("There was an issue with barcode");
        reject(err); // Reject the promise if there's an error
      } else {
        console.log(code);
        resolve(code); // Resolve the promise with the QR code
      }
    });
  });
},
 async generateStageQrCode(stageID) {
      

    const qrData = 'https://vibe-tap.com/performer?stageID='+stageID;

  return new Promise((resolve, reject) => {
    qr.toDataURL(qrData, function(err, code) {
      if (err) {
        console.log("There was an issue with barcode");
        reject(err); // Reject the promise if there's an error
      } else {
        console.log(code);
        resolve(code); // Resolve the promise with the QR code
      }
    });
  });
},
    openModal(item){
      this.currentBar=item;
      this.$refs.action.click();
    },
    getImg(item){
        return item.image
    }
  },
  computed:{
     venueList(){   
      if(this.$store.state.venues.length>0){
        var dataList = this.$store.state.venues.slice(0);
      dataList.unshift({_id:0,venue_name:"Please Select a Venue"});
      return dataList;
      }   
      return []
      
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.barcode-container {
  widows: 500px;
  text-align: center; /* Center the content horizontally */
  margin: 50px; /* Add space around the container */
}

.barcodeBorder {
    margin: 50px;
    padding: 15px;
    border-radius: 500px;
    -webkit-border-radius: 500px;
    -moz-border-radius: 500px;
}
.barcodeBorder {
  padding: 15px;
  border-radius: 500px;
  -webkit-border-radius: 500px;
  -moz-border-radius: 500px;
}

.barcode-subtext {
  margin-top: 10px; /* Add spacing between the image and text */
  font-size: 14px; /* Adjust text size */
  color: purple; /* Match border color for consistency */
  text-align: center;
}

.card-border {
   border: 1px solid lightgray;
   padding: 10px;
}

.color-picker {
  width: 100%;
  height: 40px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

</style>
